import { IState } from '../store';

export const selectNotAvailablePopupOpen = (state: IState): boolean => state.notAvailablePopupOpen;
